const it = {
    splash: {
        start: {
            helper: "Premi il pulsante per iniziare",
            button: "Inizia ordine"
        },
        banner: {
            title: "Benvenuto da {ORGANISATION}!",
            content: "Usa questo chiosco self-service per ordinare facilmente i tuoi biglietti di ingresso."
        }
    },
    catalog: {
        loading: "Caricamento...",
        tabs: {
            ongoing: "In corso",
            all: "Tutto"
        },
        items: {
            select: "Seleziona",
            empty: "Nessun evento in arrivo!"
        }
    },
    cart: {
        title: "La mia prenotazione",
        empty: "Non ci sono ancora biglietti nella tua prenotazione!",
        items: {
            tickets: "Biglietti",
            date: "Data",
            time: "Ora"
        },
        total: "Importo totale",
        buttons: {
            checkout: "Paga",
            cancel: "Annulla"
        }
    },
    booking: {
        steps: {
            quantity: {
                title: "Quantita biglietti"
            },
            upsell: {
                title: "Extra per il tuo ordine"
            },
            plot: {
                title: "Prenotazione",
                empty: "Non ci sono fasce di prenotazione disponibili.",
                now: "Hai selezionato una fascia di prenotazione per entrare subito.",
                change: "Modifica"
            }
        },
        buttons: {
            continue: "Continua",
            return: "Indietro",
            cancel: "Annulla"
        }
    },
    checkout: {
        loading: "Caricamento...",
        steps: {
            payment: "Completa il pagamento sul terminale di pagamento...",
            acts: {
                payment: "Completa il pagamento con carta o contanti...",
                paymentLeft: "Devi ancora pagare {paymentLeft}",
                cancel: "Annulla"
            },
            tickets: "Pagamento riuscito! Ritira i tuoi biglietti...",
            tickets_info: "Vuoi ricevere anche una ricevuta del pagamento?",
            receipt: "Ritira la tua ricevuta...",
            receipt_info: "La tua ricevuta di pagamento e stata stampata.",
            failures: {
                transaction: {
                    title: "Il pagamento non e stato completato!",
                    description: "Puoi provare a eseguire di nuovo la transazione."
                },
                print: {
                    title: "Non e stato possibile stampare biglietti e ricevuta!",
                    description: "Chiedi a un membro del personale di controllare la stampante. I tuoi biglietti e la ricevuta verranno comunque stampati dopo."
                }
            },
            error: "Non e stato possibile effettuare l'ordine!"
        },
        buttons: {
            retry: "Riprova",
            cancel: "Indietro",
            next: "Cliente successivo",
            yes: "Si",
            yes_info: "Voglio una ricevuta!",
            no: "No",
            no_info: "Nessuna ricevuta necessaria!",
            reprint_tickets: "Ristampa biglietti",
            reprint_tickets_countdown: "Ristampa biglietti ({seconds}s)"
        }
    },
    errors: {
        audience_not_found: "Il pubblico di destinazione non e stato trovato.",
        captcha_invalid: "Il CAPTCHA non e valido. Ricarica la pagina ed effettua di nuovo l'ordine.",
        coupon_expired: "Questo coupon e scaduto.",
        coupon_invalid: "Il codice coupon inserito non e valido.",
        coupon_product_mismatch: "Questo coupon non puo essere usato per questo prodotto.",
        coupon_redemptions_exceeded: "Questo coupon e stato completamente utilizzato.",
        customer_field_invalid: "Un campo del modulo non e compilato correttamente. Controlla i tuoi dati.",
        customer_field_missing: "Manca un campo del modulo. Controlla i tuoi dati.",
        customer_token_invalid: "Il token cliente non e valido. Accedi di nuovo.",
        customer_token_required: "Questo indirizzo e-mail e gia registrato. Accedi prima di effettuare un ordine.",
        plot_capacity_insufficient: "La fascia di prenotazione che stai cercando di ordinare non ha piu disponibilita. Selezionane un'altra.",
        plot_not_found: "La fascia di prenotazione che stai cercando di ordinare non e piu disponibile.",
        product_max_quantity_exceeded: "Il numero di biglietti supera il massimo consentito. Riduci la quantita.",
        product_min_quantity_exceeded: "Il numero di biglietti e inferiore al minimo richiesto. Aumenta la quantita.",
        product_not_found: "Il prodotto che stai cercando di ordinare non e piu disponibile.",
        rebook_invalid: "La modifica della prenotazione non e valida.",
        rebook_product_mismatch: "La modifica della prenotazione non puo essere usata con il prodotto specificato.",
        subscription_expired: "L'abbonamento e scaduto.",
        subscription_inactive: "L'abbonamento non e piu attivo. Probabilmente la disponibilita e insufficiente.",
        subscription_invalid: "L'abbonamento non e valido.",
        subscription_not_found: "L'abbonamento specificato non e stato trovato.",
        subscription_product_mismatch: "L'abbonamento non consente l'accesso a questo prodotto.",
        subscription_quantity_mismatch: "L'abbonamento non consente l'accesso a queste quantita.",
        subscription_redemptions_exceeded: "L'abbonamento ha superato il suo utilizzo massimo.",
        subscription_used_today: "L'abbonamento e gia stato utilizzato oggi.",
        upsell_not_allowed: "Questo extra non puo essere ordinato insieme a questo prodotto.",
        upsell_not_found: "L'extra non e stato trovato."
    },
    printer: {
        title: "Si e verificato un errore della stampante!",
        reload: "Riprova",
        errors: {
            paper_empty: "La carta sta per finire.",
            cover_open: "Il coperchio e aperto.",
            device_offline: "Impossibile connettersi.",
            device_malfunction: "Si e verificato un errore generale."
        }
    }
};

export default it;
